import React from 'react';
import { AUIIconCell } from '@ancert/aui-table-cell';
import AUIButton from '@ancert/aui-button';

const getColumns = (t) => [
	{
		header: '',
		id: 'icon',
		columnWidth: 40,
		accessor: (row) => row,
		cell: <AUIIconCell icon="pdfDuotone" color="red" />,
	},
	{
		header: t('modalManuales.name'),
		id: 'name',
		minWidth: 200,
		accessor: (row) => row.name,
		cell: ({ row: { original } }) => <p>{original.name}</p>,
	},
	{
		header: '',
		id: 'link',
		columnWidth: 120,
		accessor: (row) => row.link,
		cell: ({ row: { original } }) => (
			<AUIButton
				label={t('downloadButton')}
				mode="outline"
				onClick={() => {
					window.location.href = original.link;
				}}
			/>
		),
	},
];

export default getColumns;
